import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/industrias/pharma")({
  head: () => buildRouteHead("/es/industrias/pharma", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/industrias/pharma-biotech", replace: true });
  },
});
